export var defaultProps = {
    className: '',
    style: undefined,
    data: [],
    header: null,
    footer: null,
    renderItem: function (item, index) { },
};
export var defaultListItemProps = {
    extra: null,
    note: null,
    style: undefined,
    itemLayout: '',
};
export var defaultListItemMetaProps = {
    className: '',
    style: undefined,
    avatar: null,
    description: null,
    title: null,
};
